import React,{ useState, useEffect } from "react";
import { Select, Input, Button, Form, Alert } from 'antd';
import axios from 'axios';

function Referrals( { paymentReceived } ) {
    const [referralProcessing, setReferralProcessing] = useState(false);
    const [referralSelection, setReferralSelection] = useState('');
    const [referralFriendName, setReferralFriendName] = useState('');
    const [referralNotification, setReferralNotification] = useState(<></>);
    const [referralSubmitted, setReferralSubmitted] = useState(false);
    const [form] = Form.useForm();

    const handleChange = ( value ) => {
        setReferralSelection( value );
    }

    const handleReferralFriendChange = ( e ) => {
        setReferralFriendName( e.target.value );
    }

    const handleSubmitReferral = ( e ) => {
        setReferralProcessing( true );

        let requestUrl = {ajax_url : headerVars.siteDomain+"/wp-admin/admin-ajax.php"};
        let form_data = new FormData;
        form_data.append('action', 'store_referral_data_in_session');
        form_data.append('referral_value', referralSelection );
        form_data.append('referral_friend_name', referralFriendName );

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            //console.log(response);
            setReferralProcessing( false );
            setReferralSubmitted( true );
            setReferralNotification(
                <Alert
                    message="Thanks for your submission!"
                    description=""
                    type="success"
                    showIcon
                />
            );
        })
        .catch(function (error) {
            console.log(error);
            setReferralProcessing( false );
            setReferralNotification(
                <Alert
                    message="There was a problem with your submission."
                    description=" Please try again later"
                    type="error"
                    showIcon
                    closable
                />
            );
        })
        .finally(function () {
            // always executed 
        }); 
    }
    
    return ( 
        <div class="checkout-success-referral-content-container" style={{ 'display':(paymentReceived) ? 'block' : 'none' }}>
            <div className="order-summary-h2">Let us know how you heard about us!</div>
            <div class="referral-input-container">
                <Form>
                    <Form.Item
                        label="I heard about Start.ca from..."
                        labelCol={{ span: 24 }}
                        name="referral-source"
                        style={{marginBottom:'1rem', width:'100%'}}
                        rules={[
                            {
                            required: false,
                            message: '',
                            },
                        ]}
                    >
                        <Select
                            defaultValue=""
                            id="referral-source"
                            style={{
                                //width: 120,
                            }}
                            onChange={handleChange}
                            options={[
                                {
                                value: '',
                                label: 'Select Referral source',
                                },
                                {
                                value: 'referral',
                                label: 'A friend or family member',
                                },
                                {
                                value: 'billboard',
                                label: 'Billboard',
                                },
                                {
                                value: 'bus-ad',
                                label: 'Bus Ad',
                                },
                                {
                                value: 'event',
                                label: 'Event',
                                },
                                {
                                value: 'IGYB911',
                                label: 'IGYB911',
                                },
                                {
                                value: 'online-review',
                                label: 'Online Review',
                                },
                                {
                                value: 'online-ad',
                                label: 'Online Advertisement',
                                },
                                {
                                value: 'radio',
                                label: 'Radio',
                                },
                                {
                                value: 'social-media',
                                label: 'Social Media',
                                },
                                {
                                value: 'web-search',
                                label: 'Web Search',
                                },
                                {
                                value: 'word-of-mouth',
                                label: 'Word of Mouth',
                                }
                            ]}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Say thanks by entering the person's name to save them $50 off their next bill!"
                        labelCol={{ span: 24 }}
                        name="referral-source"
                        style={{marginTop:'1rem', width:'100%', display:( referralSelection == 'referral' ) ? 'block' : 'none'}}
                        rules={[
                            {
                            required: false,
                            message: '',
                            },
                        ]}
                    >
                        <Input 
                            id="friend-referral-input" 
                            class="" 
                            type="text" 
                            placeholder="Enter name here" 
                            value=""
                            onChange= { handleReferralFriendChange }
                        />
                    </Form.Item>
                    <div style={{ marginBottom: '1rem' }}>
                        { referralNotification }
                    </div>
                    <Button
                        type="default"
                        //style={{margin:'1rem 0'}}
                        loading={referralProcessing}
                        onClick={ handleSubmitReferral }
                        disabled={ referralSubmitted }
                    >
                        Submit
                    </Button>
                </Form>
            </div>
       </div>
    )
}

export default Referrals